/** Utility function to create a K:V from a list of strings */
export function strEnum<T extends string>(o: Array<T>): {[K in T]: K} {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null));
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/utils/strenum.ts